export default {"src":"https://wp-static.smartkarma.com/_next/static/media/download.93358ae9.svg","height":252,"width":199,"blurWidth":0,"blurHeight":0};